;'use strict';
$(document).ready(function() {
    const $body = $('body');
    const $mobileMenuBtn = $('.mm__open-menu');
    const $mobileToggleNav = $('.mobile--menu');
    const $aislesToggleNav = $('.aisles--menu');
    const $shopInshopToggleNav = $('.shop-in-shop--menu');

    const $navCoreLink = $('.container__bottom a, .container__bottom button');
    $navCoreLink.each(function(){
        let $this = $(this);
        let isCoreLink = $this.data('core-link');
        if (isCoreLink) {
            $this.closest('li').addClass('nav--core-link');
        }
    });

    const closeMenuNav = function (mobileMenu) {
        $body.removeClass('overflow-hidden');
        $('.aisles--btn').attr('aria-expanded', false);
        $('.shop-in-shop--btn').attr('aria-expanded', false);
        $mobileMenuBtn.attr('aria-expanded', false).removeClass('active');
        $('.nav-overlay').remove();
        $('.sub-nav-head').removeClass('three-col');
        $('.sub-nav-head').removeClass('two-col');
        $('.aisles--subNav--lev2').empty();
        $('.aisles--subNav--lev3').empty();
        $('.active--nav').removeClass('active--nav');
        $('.btn-display-aisle').attr('aria-expanded', false);
        $('.hide-overflow').removeClass('hide-overflow');
        $aislesToggleNav.removeClass('active');
        $aislesToggleNav.addClass('inactive');
        $shopInshopToggleNav.removeClass('active');
        $shopInshopToggleNav.addClass('inactive');
        if (mobileMenu != false) {
            $mobileToggleNav.removeClass('active');
            $mobileToggleNav.addClass('inactive');
        }
        closeItemToggle();
    }

    const manageCloseNavOverlay = function () {
        $('.nav-overlay').on('click', function (e) {
            if (e.target === this) {
                closeMenuNav();
            }
        });
    }

    const showToggleMenu = function (elm, toggleType, toggleTab) {
        $('.nav-overlay').remove();
        $body.addClass('overflow-hidden');
        $mobileMenuBtn.addClass('active').attr('aria-expanded', true);
        toggleTab.addClass('active');
        toggleTab.removeClass('inactive');
        if (toggleType == 'aisles') {
            elm.attr('aria-expanded', true);
            $mobileToggleNav.addClass('active');
            $mobileToggleNav.removeClass('inactive');
            $aislesToggleNav.append('<span class="nav-overlay" />');
        } else if (toggleType == 'shop-in-shop') {
            elm.attr('aria-expanded', true);
            $mobileToggleNav.addClass('active');
            $mobileToggleNav.removeClass('inactive');
            $shopInshopToggleNav.append('<span class="nav-overlay" />');
        } else {
            $mobileToggleNav.append('<span class="nav-overlay" />');
        }
        if (Revealizr.isDesktopSize) {
            $('.navigation__btn--close').focus();
            let $lastAisleElm =  $('.aisles--menu').find('li').last();
            headerMenuAisle.aisleMenuFocusTrap($lastAisleElm);
        }
        manageCloseNavOverlay();
    };

    $('.aisles--btn').click(function () {
        let $this = $(this);
        if ($this.attr('aria-expanded') === 'false') {
            showToggleMenu($this, 'aisles', $aislesToggleNav);
        } else {
            closeMenuNav();
        }
    });

    $('.shop-in-shop--btn').click(function () {
        let $this = $(this);
        if ($this.attr('aria-expanded') === 'false') {
            showToggleMenu($this, 'shop-in-shop', $shopInshopToggleNav);
        } else {
            closeMenuNav();
        }
    });

    $('.link-confirmation').click(function (event) {
        if (!isAuthenticated) {
            loginSidePanel();
            event.preventDefault();
            return false;
        }
    });

    $mobileMenuBtn.click(function () {
        let $this = $(this);
        if ($this.attr('aria-expanded') === 'false') {
            showToggleMenu($this, 'mobileNav', $mobileToggleNav);
        } else {
            closeMenuNav();
        }
    });

    $('.navigation__btn--close').click(function () {
        closeMenuNav();
    });

    $('.aisles--lvl-1').click(function () {
        closeMenuNav(true);
        showToggleMenu(false, 'mobileNav', $mobileToggleNav);
    });

    $('.aisles--lvl-2').click(function () {
        $('.sub--nav--second').removeClass('active--nav');
        $('.btn-display-aisle').attr('aria-expanded', false);
        $('.sub--nav--first').removeClass('hide-overflow');
    });

    $('.aisles--lvl-3').click(function () {
        $('.sub--nav--third').removeClass('active--nav');
        $('.active--sub-nav').removeClass('active--sub-nav');
        $('.sub--nav--second').removeClass('hide-overflow');
    });

    // TOGGLE MENU ITEM
    let toggleItemActive = 0;

    let manageFilterOuterClick = function (toggleBtn, toggleBox, toggleItemActive) {
        let btnElm =  toggleBtn[0];
        let boxElm =  toggleBox[0];
        $(document).on('click', function( event ) {
            if (toggleItemActive && btnElm !== event.target && !btnElm.contains(event.target) && boxElm !== event.target && !boxElm.contains(event.target)) {
                closeItemToggle();
                return false;
            }
        });
    }
    const openMenuToggle = function (toggleBtn, toggleBox, mobileMenuBtn) {
        toggleBtn.attr('aria-expanded', 'true');
        $('.metro-menu .container__bottom').addClass('fix-overflow');
        $('.mobile--menu .nav--container').addClass('overflow-hidden');
        toggleBox.addClass('activeBox');
        toggleItemActive = 1;

        if (!mobileMenuBtn) {
            showToggleMenu(false, 'mobileNav', $mobileToggleNav);
        } else {
            manageFilterOuterClick(toggleBtn, toggleBox, toggleItemActive);
        }

    }
    const closeItemToggle = function () {
        $('.toggleBtn').attr('aria-expanded', 'false');
        $('.toggleBox').removeClass('activeBox');
        $('.mobile--menu .nav--container').removeClass('overflow-hidden');
        $('.metro-menu .container__bottom').removeClass('fix-overflow');
        toggleItemActive = 0;
    }
    $('.mobile--menu .toggleBtn').on('click', function() {
        let $this = $(this);
        let $toggleBox = $this.next('.toggleBox');
        if (toggleItemActive) {
            closeItemToggle();
        } else {
            openMenuToggle($this, $toggleBox, true);
        }
    });
    $('.container__bottom .toggleBtn').on('click', function() {
        let $this;
        let desktopSize;
        if (!Revealizr.isDesktopSize) {
            $this = $('.mobile--menu .toggleBtn');
            desktopSize = false;
        } else {
            $this = $(this);
            desktopSize = true;
        }
        let $toggleBox = $this.next('.toggleBox');

        if (toggleItemActive) {
            closeItemToggle();
        } else {
            openMenuToggle($this, $toggleBox, desktopSize);
        }
    });
    $('.close-toggle-box, .close-toggle-box-arrow').on('click', function() {
        closeItemToggle();
    });

});

var defaultPublicity = {};
$(document).ready(function () {
    var $burgerMenu = $('.header-menu-primary');
    var containsPublicity = $burgerMenu.has('.hsm__ad');
    if (containsPublicity) {
        defaultPublicity.linkHref = $burgerMenu.find('.hsm__ad a').attr('href');
        defaultPublicity.linkTitle = $burgerMenu.find('.hsm__ad a').attr('title');
        defaultPublicity.linkOnclick = $burgerMenu.find('.hsm__ad a').attr('onclick');
        defaultPublicity.linkGaType = $burgerMenu.find('.hsm__ad a').attr('data-ga-type');
        defaultPublicity.imgSrc = $burgerMenu.find('.hsm__ad a img').attr('src');
        defaultPublicity.imgAlt = $burgerMenu.find('.hsm__ad a img').attr('alt');
        defaultPublicity.imgStyle = $burgerMenu.find('.hsm__ad a img').attr('style');
    }
});

function updatePublicity(open, pathBigMenuEn) {
    var $burgerMenu = $('.header-menu-primary');
    var containsPublicity = $burgerMenu.has('.hsm__ad');
    if (open && pathBigMenuEn) {
        var $firstPublicity = $('#main-menu .mn--' + pathBigMenuEn + ' .mn--ads .mn--ad a').first();
        if ($firstPublicity.length) {
            if (!containsPublicity.length) {
                $burgerMenu.append('<div class="hsm__ad padding-medium"><span><a><img alt=""></a></span></div>');
            }
            $burgerMenu.find('.hsm__ad a').attr('href', $firstPublicity.attr('href'));
            $burgerMenu.find('.hsm__ad a').attr('title', $firstPublicity.attr('title'));
            $burgerMenu.find('.hsm__ad a').attr('onclick', $firstPublicity.attr('onclick'));
            $burgerMenu.find('.hsm__ad a').attr('data-ga-type', $firstPublicity.attr('data-ga-type'));
            $burgerMenu.find('.hsm__ad a img').attr('src', $firstPublicity.find('img').attr('src'));
            $burgerMenu.find('.hsm__ad a img').attr('alt', $firstPublicity.find('img').attr('alt'));
            $burgerMenu.find('.hsm__ad a img').attr('style', $firstPublicity.find('img').attr('style'));
        }
    } else if (!open) {
        if (defaultPublicity.imgSrc !== undefined) {
            $burgerMenu.find('.hsm__ad a').attr('href', defaultPublicity.linkHref);
            $burgerMenu.find('.hsm__ad a').attr('title', defaultPublicity.linkTitle);
            $burgerMenu.find('.hsm__ad a').attr('onclick', defaultPublicity.linkOnclick);
            $burgerMenu.find('.hsm__ad a').attr('data-ga-type', defaultPublicity.linkGaType);
            $burgerMenu.find('.hsm__ad a img').attr('src', defaultPublicity.imgSrc);
            $burgerMenu.find('.hsm__ad a img').attr('alt', defaultPublicity.imgAlt);
            $burgerMenu.find('.hsm__ad a img').attr('style', defaultPublicity.imgStyle);
        } else {
            $burgerMenu.find('.hsm__ad').remove();
        }
    }
}


// Big menu
$('.dataLayerBigMenuTrending').click(function () {
    pushDataLayerBigMenuSubsiteTrending('big menu', $(this).children('a:first-child').text().toLowerCase());
});

$('.dataLayerBigMenuLevelOne').click(function () {
    var menuName = Revealizr.isMobileSize || Revealizr.isTabletSize ? 'big menu hamburger' : 'big menu';
    var levelName = $(this).data('menu-name') != undefined ? $(this).data('menu-name').replace('-', ' ').trim().toLowerCase() : 'undefined';
    pushDataLayerBigMenuLevel(menuName, levelName);
});

$(document).on('click', '.dataLayerBigMenuLevelTwo', function () {
    var menuName = Revealizr.isMobileSize || Revealizr.isTabletSize ? 'big menu hamburger' : 'big menu';
    var levelName = (($(this).data('menu-name') != undefined && !$(this).data('menu-name').includes("big-menu-burger")) ? $(this).data('menu-name').trim().toLowerCase() + ' | ' : '') +
        ($(this).data('sub-menu-name') != undefined ? $(this).data('sub-menu-name').trim().toLowerCase() : 'undefined');

    pushDataLayerBigMenuLevel(menuName, levelName);
    $(this).focus();
});

$(document).on('click', '.dataLayerBigMenuLevelThree', function () {
    var menuName = Revealizr.isMobileSize || Revealizr.isTabletSize ? 'big menu hamburger' : 'big menu';
    var levelName = (($(this).data('menu-name') != undefined && !$(this).data('menu-name').includes("big-menu-burger")) ? $(this).data('menu-name').trim().toLowerCase() + ' | ' : '') +
        ($(this).data('sub-menu-name') != undefined ? $(this).data('sub-menu-name').trim().toLowerCase() : 'undefined') + ' | ' +
        ($(this).data('child-menu-name') != undefined ? $(this).data('child-menu-name').trim().toLowerCase() : 'undefined');

    pushDataLayerBigMenuLevel(menuName, levelName);
});

$(document).on('click', '.dataLayerBigMenuLevelFour', function () {
    var menuName = Revealizr.isMobileSize || Revealizr.isTabletSize ? 'big menu hamburger' : 'big menu';
    var levelName = (($(this).data('menu-name') != undefined && !$(this).data('menu-name').includes("big-menu-burger")) ? $(this).data('menu-name').trim().toLowerCase() + ' | ' : '') +
        ($(this).data('sub-menu-name') != undefined ? $(this).data('sub-menu-name').trim().toLowerCase() : 'undefined') + ' | ' +
        ($(this).data('child-menu-name') != undefined ? $(this).data('child-menu-name').trim().toLowerCase() : 'undefined') + ' | ' +
        ($(this).data('grand-child-menu-name') != undefined ? $(this).data('grand-child-menu-name').trim().toLowerCase() : 'undefined');

    pushDataLayerBigMenuLevel(menuName, levelName);
});

// Big menu hamburger
$('.dataLayerBigMenuHamburgerSubsiteMetro').click(function () {
    pushDataLayerBigMenuSubsite('big menu hamburger', 'metro');
});

$('.dataLayerBigMenuHamburgerSubsiteOnlineGrocery').click(function () {
    pushDataLayerBigMenuSubsite('big menu hamburger', 'online grocery');
});

$('.dataLayerBigMenuThemeZone,.ht__link-featured').click(function () {
    pushDataLayerBigMenuThemeZone('big menu hamburger', $('.dataLayerBigMenuThemeZoneLabel,.ht_link-featured__label').text());
});

$('.dataLayerBigMenuTopButton').click(function () {
    pushDataLayerBigMenuTopButton(
        ($(this).data('menu-name') != undefined ? $(this).data('menu-name').trim().toLowerCase() : 'undefined') + ' | button ' +
        ($(this).data('sub-menu-name') != undefined ? $(this).data('sub-menu-name').trim().toLowerCase() : 'undefined'));
});

$('.dataLayerHeaderFavoriteStore').click(function () {
    pushDataLayerHeaderActionLink('my store clicks', 'my favourite store : ' + $(this).find('.store-name').text());
});

$('#authenticatedButton').click(function () {
    pushDataLayerHeaderActionLink('connected - user name clicks', 'user name clicks');
});

$('.footer-top [data-ga-id]').click(function () {
    pushDataLayerTopFooterActionLink($.trim($(this).text()));
});

$('.head--sub__footer a').click(function () {
    pushDataLayerTopFooterActionLink($.trim($(this).text()));
});

$('.footer--main [data-ga-id]').click(function () {
    pushDataLayerBottomFooterActionLink($.trim($(this).text()));
});

$('.choose-new-service-pickup').click(function () {
    var eventCategory = Revealizr.isMobileSize || Revealizr.isTabletSize ? 'big menu hamburger' : 'black header clicks';
    pushDataLayerChooseNewService(eventCategory, 'pickup service clicks', 'pickup service button');
});

$('.choose-new-service-delivery').click(function () {
    var eventCategory = Revealizr.isMobileSize || Revealizr.isTabletSize ? 'big menu hamburger' : 'black header clicks';
    pushDataLayerChooseNewService(eventCategory, 'delivery service clicks', 'delivery service button');
});